/**
 * CommissionTable Component
 * 수수료 테이블 컴포넌트
 */
import React from 'react';
import Pagination from '@/shared/components/dataDisplay/Pagination';
import { SupplierCommissionRow, PeriodType } from '../types/feeManagement.types';
import { TABLE_COLUMN_COUNT, ITEMS_PER_PAGE } from '../lib/feeManagement.helpers';
import CommissionTableRow from './CommissionTableRow';

interface CommissionTableProps {
    /** 현재 페이지 항목 */
    currentItems: SupplierCommissionRow[];
    /** 현재 페이지 */
    currentPage: number;
    /** 전체 페이지 수 */
    totalPages: number;
    /** 페이지 변경 핸들러 */
    onPageChange: (page: number) => void;
    /** 초기값 일괄 설정 핸들러 */
    onSetDefaultValues: () => void;
    /** 페이백 초기값 일괄 설정 핸들러 */
    onSetDefaultPayback: () => void;
    /** 수수료 구분 변경 핸들러 (새 수수료 입력용) */
    onNewCommissionTypeChange: (supplierId: string, period: PeriodType, value: string) => void;
    /** 금액 변경 핸들러 (새 수수료 입력용) */
    onNewAmountChange: (supplierId: string, period: PeriodType, value: string) => void;
    /** 페이백 사용여부 변경 핸들러 */
    onNewPaybackUseYnChange: (supplierId: string, value: string) => void;
    /** 페이백 금액 변경 핸들러 */
    onNewPaybackAmountChange: (supplierId: string, value: string) => void;
    /** 새 시작일자 변경 핸들러 */
    onNewStartDateChange: (supplierId: string, value: string) => void;
    /** 히스토리 조회 핸들러 */
    onShowHistory: (supplierId: string, supplierName: string) => void;
    /** 저장 핸들러 */
    onSave: (supplierId: string) => void;
    /** 일괄 저장 핸들러 */
    onSaveAll: () => void;
    /** 수수료변경 토글 핸들러 */
    onToggleFeeChange: (supplierId: string) => void;
}

const CommissionTable: React.FC<CommissionTableProps> = ({
    currentItems,
    currentPage,
    totalPages,
    onPageChange,
    onSetDefaultValues,
    onSetDefaultPayback,
    onNewCommissionTypeChange,
    onNewAmountChange,
    onNewPaybackUseYnChange,
    onNewPaybackAmountChange,
    onNewStartDateChange,
    onShowHistory,
    onSave,
    onSaveAll,
    onToggleFeeChange
}) => {
    /** 테이블 인덱스 계산 */
    const getTableIndex = (index: number): number => {
        return (currentPage - 1) * ITEMS_PER_PAGE + index + 1;
    };

    return (
        <>
            <div className="table-container" style={{ overflowX: 'auto' }}>
                <table className="supplier-selection-table" style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th style={{ width: '4%' }} rowSpan={2}>NO</th>
                            <th style={{ width: '12%' }} rowSpan={2}>협력사명</th>
                            <th
                                style={{
                                    width: '24%',
                                    cursor: 'pointer',
                                    backgroundColor: '#f0f9ff'
                                }}
                                colSpan={2}
                                onClick={onSetDefaultValues}
                                title="클릭하여 모든 협력사에 초기값 설정"
                            >
                                수수료 💡
                            </th>
                            <th
                                style={{
                                    width: '12%',
                                    cursor: 'pointer',
                                    backgroundColor: '#f0f5ff'
                                }}
                                rowSpan={2}
                                onClick={onSetDefaultPayback}
                                title="클릭하여 모든 협력사에 페이백 초기값 설정 (30원)"
                            >
                                페이백(건당) 💡
                            </th>
                            <th style={{ width: '10%' }} rowSpan={2}>적용일</th>
                            <th style={{ width: '10%' }} rowSpan={2}>수수료변경<br/>히스토리</th>
                            <th
                                style={{
                                    width: '8%',
                                    cursor: 'pointer',
                                    backgroundColor: '#fffbde'
                                }}
                                rowSpan={2}
                                onClick={onSaveAll}
                                title="클릭하여 변경된 모든 협력사 수수료 일괄 저장"
                            >
                                저장 💾
                            </th>
                            <th style={{ width: '8%' }} rowSpan={2}>수수료변경</th>
                        </tr>
                        <tr>
                            <th style={{ width: '12%' }}>선정산</th>
                            <th style={{ width: '12%' }}>주정산</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentItems.length === 0 ? (
                            <tr>
                                <td colSpan={TABLE_COLUMN_COUNT} className="text-center text-gray-600">
                                    조회된 협력사가 없습니다.
                                </td>
                            </tr>
                        ) : (
                            currentItems.map((row, index) => (
                                <CommissionTableRow
                                    key={row.supplierId}
                                    row={row}
                                    index={getTableIndex(index)}
                                    onNewCommissionTypeChange={onNewCommissionTypeChange}
                                    onNewAmountChange={onNewAmountChange}
                                    onNewPaybackUseYnChange={onNewPaybackUseYnChange}
                                    onNewPaybackAmountChange={onNewPaybackAmountChange}
                                    onNewStartDateChange={onNewStartDateChange}
                                    onShowHistory={onShowHistory}
                                    onSave={onSave}
                                    onToggleFeeChange={onToggleFeeChange}
                                />
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* 페이지네이션 */}
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
            />
        </>
    );
};

export default CommissionTable;
